/**
 * MGT PDP Hero
 * Gallery thumb switching, quantity stepper, and sticky buy-bar visibility.
 * Binds to every [data-mgt-hero] root so multiple instances stay isolated.
 * ponytail: sticky bar paired as the hero root's next [data-mgt-stickybar] sibling;
 * one hero per PDP, so a global lookup would also do — scoped lookup keeps it instance-safe.
 */
function initHeroInstance(root) {
  const main = root.querySelector('[data-mgt-main]');
  const thumbs = root.querySelectorAll('[data-mgt-thumb]');
  // FrontrowMD sticker is pinned to the (single) frame; hide it unless the first
  // image is showing, since thumbs swap the image in place rather than per-slide.
  const frame = root.querySelector('[data-frontrow-image]');

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      // clear srcset so the responsive LCP srcset stops overriding the swapped src
      if (main && thumb.dataset.full) { main.removeAttribute('srcset'); main.src = thumb.dataset.full; }
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (frame) frame.toggleAttribute('data-frontrow-inactive', index !== 0);
    });
  });

  const qtyInput = root.querySelector('.mgt-pdp-qty input');
  const minus = root.querySelector('[data-mgt-qty="minus"]');
  const plus = root.querySelector('[data-mgt-qty="plus"]');
  if (qtyInput && minus && plus) {
    minus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    plus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  const bar = document.querySelector('[data-mgt-stickybar]');
  const buyRef = root.querySelector('.mgt-pdp-hero__buy');
  if (bar && buyRef && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          bar.classList.toggle('is-visible', !e.isIntersecting);
          bar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
        });
      },
      { threshold: 0 }
    );
    io.observe(buyRef);
  }
}

export default function initMgtHero() {
  document.querySelectorAll('[data-mgt-hero]').forEach(initHeroInstance);
}
